import { filter, forEach, isString, map } from 'lodash4';

export class MyScheduleHelperFunction {
  private MEMOIZED_COLOR_NKS = {};
  private cssCounter = 1;

  static build(): MyScheduleHelperFunction {
    return new MyScheduleHelperFunction();
  }

  getScheduleCSSClass(nk: string, colorLocation?: string) {
    if (this.cssCounter > 12) {
      this.cssCounter = 1;
    }

    if (!this.MEMOIZED_COLOR_NKS[nk]) {
      this.MEMOIZED_COLOR_NKS[nk] = `clr-${this.cssCounter}`;
      this.cssCounter++;
    }

    return `${this.MEMOIZED_COLOR_NKS[nk]}-${isString(colorLocation) ? colorLocation : 'txt'}`;
  }

  convertScheduleTimesForCalendar(schedule: any, isThisWeek: boolean) {
    let calendarSchedule: any = [];
    const self = this;
    const weekStart = moment().startOf('week').subtract(1, 'day');
    const weekEnd = moment().endOf('week');

    forEach(schedule, (course) => {
      const { _course } = course;
      calendarSchedule = calendarSchedule.concat(
        map(
          filter(course._sectionTime, ({ day_of_week }) => {
            if (!isThisWeek) {
              return true;
            }
            return course.class_end_dt.isAfter(weekStart) && course.class_start_dt.isBefore(weekEnd);
          }),
          ({ day_of_week, from_tm, to_tm }) => {
            return {
              appId: course.id,
              content: _course.cd,
              bkgColorClass: self.getScheduleCSSClass(_course.nk, 'bkg'),
              day_of_week,
              from_tm,
              to_tm
            };
          }
        )
      );
    });

    return calendarSchedule;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/functions/my_schedule_fn.ts